import React, { useState } from "react";

function ApiButton({ onClick, children, once = false, ...props }) {
    const [loading, setLoading] = useState(false);
    const [clicked, setClicked] = useState(false);

    const handleClick = async (e) => {
        if (loading || (once && clicked)) return; // block extra clicks

        e.preventDefault(); // only needed if button inside <form>
        setLoading(true);

        try {
            await onClick(e);
            if (once) setClicked(true); // lock button forever if once=true
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);       // stop loading, but keep disabled
        }
    };

    return (
        <button
            onClick={handleClick}
            disabled={loading || clicked || props.disabled}
            {...props}
        >
            {loading ? "Loading..." : children}
        </button>
    );
}

export default ApiButton;
